import * as ui from '../../ui/index.js';

/**
 * Loader for the FeedbackWidget module
 * 
 * @author rhess <robin.hess@awi.de>
 * @author sjaswal <shahzeib.jaswal@awi.de> 
 */

/**
 * A function that loads the FeedbackWidget
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function FeedbackWidget(options, viewer) {
    viewer.addElement(options.id, new ui.FeedbackWidget(null, options));
}